import React from 'react';
import {
  ImagesContainer, ImagesWrapper, Image, ImagesHolder,
} from './imagesElements';

// Images
import Img1 from '../../../Images/Home/Picture1.jpg';
import Img2 from '../../../Images/Home/Picture2.jpg';
import Img3 from '../../../Images/Home/Picture3.jpg';
import Img4 from '../../../Images/Home/Picture4.jpg';
import Img5 from '../../../Images/Home/Picture5.jpg';
import Img6 from '../../../Images/Home/Picture6.jpg';

const index = () => (
  <ImagesContainer>
    <ImagesWrapper>
      <ImagesHolder>
        <Image alt="Background" src={Img1} />
        <Image alt="Background" src={Img2} />
        <Image alt="Background" src={Img3} />
        <Image alt="Background" src={Img4} />
        <Image alt="Background" src={Img5} />
        <Image alt="Background" src={Img6} />
      </ImagesHolder>
    </ImagesWrapper>
  </ImagesContainer>
);

export default index;
